
<template>

	<setup_content class="h-100 d-flex" style="flex-direction: column;position: relative;" title="Объекты-аналоги для построения статистической модели">

		<importBadFromXLSX ref="import_bad_from_xlsx" :group_id="group_id" v-on:need_refresh="refresh"/>

		<div class="d-flex justify-content-end" style="gap: .5rem">

			<v-select style="width: calc(50% - 70px - 1.5rem); display: inline-block" v-model="plot_type" :options="plot_types" :clearable="false" required v-on:input="value => plot_type_changed(value)"/>

			<b-button v-if="check_roles([ 'model' ])" size="sm" variant="outline-primary" class="filter-button" v-b-tooltip:fullscreen.hover.bottomright title="Вернуть в исходное состояние" v-on:click="reset_state">
				<base-icon name="broomstick" />
			</b-button>
			<b-button v-if="check_roles([ 'model' ])" size="sm" variant="outline-primary" class="filter-button" v-b-tooltip:fullscreen.hover.bottomright title="Отмена последнего действия" v-on:click="() => $emit('bring_back')">
				<base-icon name="actions_undo"/>
			</b-button>

		</div>

		<statistic_plot :data="data"/>

		<elements
			v-if="group_id"
			ref="objects"
			service="cadastral_analogues"
			:postfix_for_storage_name="'modeling_' + id"
			without_add
			:attrs="attrs"
			:raw_query="{ group : group_id, analogues_profitable_type : 'Купля-продажа' }"
			not_able_for_delete
			with_filters
			essence_name_genetive_case="объекта-аналога"
			essence_name_for_plural_1="объект-аналог"
			essence_name_for_plural_234="объекта-аналога"
			essence_name_for_plural_others="объектов-аналогов"
			without_back_button
			initial_per_page="5"
			initial_sort_by="current_version.attrs.group_code"
			:initial_sort_desc="false"
			elements_table_height="25vh"
			:export_to_xlsx_extra="{ model_type : model_type }"
			:get_many_extra="{ model_type : model_type }"
			v-on:filters_ready="() => filters_ready()"
		>

			<template v-slot:title>

				<h4>Выборка объектов-аналогов</h4>

			</template>

			<template v-slot:first_nav_items>

				<v-select v-model="model_type" :options="model_type_options" :clearable="false" style="width: 320px;" />

			</template>

			<template v-slot:nav_items_before_export>

				<b-button v-if="check_roles([ 'model' ])" variant="outline-primary" class="nav-button" v-b-tooltip:fullscreen.hover.bottomright title="Импорт" v-on:click="import_bad_from_xlsx"><base-icon name="upload"/></b-button>

			</template>

			<template v-slot:table_cell_params="cell">

				<span v-if="cell.data.field.key == 'diff'">

					<span v-if="cell.data.item.diff && cell.data.item.diff[model_type]">
						
						{{ round2( cell.data.item.diff[model_type] ) }}

					</span>
				
				</span>

				<span v-if="cell.data.field.key == 'diff_percentage'">

					<span v-if="cell.data.item.diff_percentage && cell.data.item.diff_percentage[model_type]">
						
						{{ round2( cell.data.item.diff_percentage[model_type] ) }}

					</span>
				
				</span>

				<span v-if="cell.data.field.key == 'model_cost'">

					<span v-if="cell.data.item.model_cost && cell.data.item.model_cost[model_type]">
						
						{{ round2( cell.data.item.model_cost[model_type] ) }}

					</span>
				
				</span>

			</template>

		</elements>

	</setup_content>

</template>

<script>

import api from "../../../../../../api"
import attrs from "../../../../../../api/attrs"
import { bus } from "../../../../../../api/bus"
import elements from "../../../../../elements"
import o from "../objects"
import importBadFromXLSX from "./import_bad_from_xlsx"
import statistic_plot from "./statistic_plot"
import setup_content from "../../setup_assets/content"

var base_attrs =
	[
		{
			key : "",
			attr_key : "attrs.group_code",
			visible : true,
			visible_if_no_visible : true,
		},
		{
			key : "",
			attr_key : "attrs.area_profitable",
			visible : true,
			visible_if_no_visible : true,
		},
		{
			key : "",
			attr_key : "attrs.uprs",
			visible : true,
			visible_if_no_visible : true,
		},
		{
			key : "",
			attr_key : "attrs.bad",
			label : "Выброс",
			visible : true,
			visible_if_no_visible : true,
		},
		{
			key : "model_cost",
			label : "Расчетная стоимость",
			sortable : true,
			visible : true,
			visible_if_no_visible : true,
			in_query : true,
			type : "number",
			params : true,
		},
		{
			key : "diff",
			label : "Невязка",
			sortable : true,
			visible : true,
			visible_if_no_visible : true,
			in_query : true,
			type : "number",
			params : true,
		},
		{
			key : "diff_percentage",
			label : "Невязка (%)",
			sortable : true,
			visible : true,
			visible_if_no_visible : true,
			in_query : true,
			type : "number",
			params : true,
		},
	]

export default
{
	props :
	{
		id : String,
		group_id : String,
		data : Object,
	},

	components :
	{
		elements,
		importBadFromXLSX,
		statistic_plot,
		setup_content,
	},

	watch :
	{
		data :
		{
			immediate : true,

			handler(data)
			{
				if(data)
				{
					var attr_ids = []

					data.attrs.forEach(attr => attr_ids.push(attr.id))

					this.new_attrs(attr_ids)

					this.model_type = this.data.type
				}
			}
		},
	},

	data()
	{
		return {

			service : "cadastral_analogues",

			plot_type : "Все",
			plot_types : [ "Все", "Не выбросы", "Обучающая выборка", "Контрольная выборка" ],

			attrs : api.deep_clone(base_attrs),

			model_type : "Экспоненциальная",
			model_type_options : [ "Линейная", "Мультипликативная степенная", "Экспоненциальная" ],

		}
	},

	mounted()
	{
		bus.$on("set_plot_type",
			ev =>
			{
				this.plot_type = ev.plot_type
			})

		o.objects().bus.$on("attrs_changed", ev => this.new_attrs(ev.ids))
		o.objects().bus.$on("refresh_statistic", () => this.$refs.objects.refresh())
	},

	methods :
	{
		check_roles(roles)
		{
			return api.check_roles(this, roles)
		},

		get_group_query()
		{
			return { "$expr" : { "$eq": [ "$current_version.group" , { "$toObjectId" : this.group_id } ] } }
		},

		new_attrs(attr_ids)
		{
			attrs.get(this).then(
				desc =>
				{
					var _attrs = desc.attrs.filter(attr => attr_ids.findIndex(id => id == attr.id) >= 0)
					var prepared_attrs = this.attrs.filter(attr => attr.model_factor == null)

					_attrs.forEach(
						attr =>
						{
							if(prepared_attrs.findIndex(_attr => _attr.attr_key == attr.key) < 0)
							{
								var prepared_attr =
								{
									key : `current_version.${attr.key}`,
									label : attr.name,
									sortable : true,
									visible : false,
									in_query : true,
									type : attr.type,
									model_factor : true,
								}

								if(attr.reference)
								{
									var simple_values = []

									attr.reference.values.forEach(value => simple_values.push({ label : api.format_reference(attr.reference, value), value : value }))

									prepared_attr.reference = { simple_values : simple_values }
								}

								prepared_attrs.push(prepared_attr)
							}
						})

					this.attrs = prepared_attrs
				})
		},

		filters_ready()
		{
			this.$refs.objects.$refs.filters.refresh(this.attrs)
		},

		import_bad_from_xlsx()
		{
			this.$refs.import_bad_from_xlsx.execute()
		},

		plot_type_changed(plot_type)
		{
			bus.$emit("set_plot_type", { plot_type : plot_type })
		},

		reset_state()
		{
			o.objects().reset_state()
		},

		refresh()
		{
			o.objects().refresh_objects().then(
				() =>
				{
					o.objects().bus.$emit("update_plots")
					o.objects().bus.$emit("evaluate_model")

					this.$refs.objects.refresh()
				})
		},

		round2(value)
		{
			return api.round2(value)
		}
	}
}

</script>
